import { Link } from 'react-router-dom';
import { useGetSettingQuery } from '../../../../Redux/Apis/siteApi';

function BestSeller() {
	const {data : {home: {best_seller : {data}}}} = useGetSettingQuery()

    return ( 
        <div className="popular-product">
			<div className="container">
				<div className="row">
					{data.lso_categories &&
						data.lso_categories.map((row,index) => 
						<div className="col-12 col-md-6 col-lg-4 mb-4 mb-lg-0" key={index}>
							<div className="product-item-sm d-flex">
								<div className="thumbnail">
									<img src={row.img_image} alt="category" className="img-fluid"/>
								</div>
								<div className="pt-3">
									<h3>{row.txt_name}</h3>
									<p>{row.txe_description}</p>
									<p><Link to={`/shop/category/${row.txt_id}`}>مشاهده دسته</Link></p>
								</div>
							</div>
						</div>
					)}
				</div>
			</div>
		</div>
    );
}

export default BestSeller;